import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function CommissionRulesAdmin() {
  const [rules, setRules] = useState(null);

  useEffect(() => {
    api.get("/admin/commission-rules").then((r) => setRules(r.data || {}));
  }, []);

  const save = async () => {
    try {
      const payload = {
        customer_cashback_pct: parseFloat(rules.customer_cashback_pct),
        platform_pct: parseFloat(rules.platform_pct),
        referral_l1_pct: parseFloat(rules.referral_l1_pct),
        referral_l2_pct: parseFloat(rules.referral_l2_pct),
        min_payout_threshold: parseFloat(rules.min_payout_threshold),
        holding_period_days: parseInt(rules.holding_period_days),
      };
      await api.put("/admin/commission-rules", payload);
      toast.success("Rules updated");
    } catch (e) {
      toast.error("Couldn't save");
    }
  };

  if (!rules) return <div className="text-gray-500">Loading…</div>;

  return (
    <div data-testid="adm-rules-page">
      <PageHeader eyebrow="Commission" title="Rules engine" subtitle="Configure how affiliate commission is split." />

      <Card className="border-gray-200 shadow-none rounded-2xl max-w-2xl">
        <CardContent className="p-6 grid sm:grid-cols-2 gap-4">
          <div><Label>Customer cashback %</Label><Input type="number" step="0.5" value={rules.customer_cashback_pct ?? 50} onChange={(e) => setRules({ ...rules, customer_cashback_pct: e.target.value })} data-testid="rule-customer" /></div>
          <div><Label>Platform %</Label><Input type="number" step="0.5" value={rules.platform_pct ?? 50} onChange={(e) => setRules({ ...rules, platform_pct: e.target.value })} /></div>
          <div><Label>Referral L1 % (of platform share)</Label><Input type="number" step="0.5" value={rules.referral_l1_pct ?? 20} onChange={(e) => setRules({ ...rules, referral_l1_pct: e.target.value })} /></div>
          <div><Label>Referral L2 %</Label><Input type="number" step="0.5" value={rules.referral_l2_pct ?? 5} onChange={(e) => setRules({ ...rules, referral_l2_pct: e.target.value })} /></div>
          <div><Label>Min payout threshold ($)</Label><Input type="number" step="1" value={rules.min_payout_threshold ?? 10} onChange={(e) => setRules({ ...rules, min_payout_threshold: e.target.value })} /></div>
          <div><Label>Holding period (days)</Label><Input type="number" value={rules.holding_period_days ?? 30} onChange={(e) => setRules({ ...rules, holding_period_days: e.target.value })} /></div>
        </CardContent>
      </Card>

      <div className="mt-4">
        <Button onClick={save} className="bg-emerald-700 hover:bg-emerald-800 text-white rounded-full" data-testid="save-rules">Save rules</Button>
      </div>
    </div>
  );
}
